import React, { useContext, useState } from 'react';
import Image from 'react-bootstrap/Image';
import Logo from '../../../margretlogo.png';
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table';
import { Col, Container, Row } from 'react-bootstrap';
import { GlobalContext } from '../../context/provider';
import moment from "moment";
import numberbeautify from '../../../utils/numberbeautify';
import '../../css/onprinttoggle.css';

const Checkoutprint = props => {
    const { employState } = useContext(GlobalContext);
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    return (
        <div className='print_show'>
            <Container>
                <Row className='justify-content-md-center mt-3'>
                    <Image src={Logo} style={{ width: 110, height: 100 }} />
                    <center><span>لیستی ژمێریاری کارمەند {employState.employ_chekout.length > 0 ? "(" + employState.employ_chekout[0].employ_name + ")" : ""}</span></center>
                </Row>
                <Row className='justify-content-md-center mt-4'>
                    <table>
                        <thead style={{ border: '2px solid', textAlign: 'center' }}>
                            <tr style={{ border: '2px solid', textAlign: 'center' }}>
                                <th>ناو</th>
                                <th>ژمارە</th>
                                <th>جۆر</th>
                                <th>بڕ</th>
                                <th>بەروار</th>
                                <th>تێبینی</th>
                            </tr>
                        </thead>
                        <tbody style={{ border: '2px solid', textAlign: 'center' }}>
                            {employState.employ_chekout.map((lis) => (
                                lis.type == "income" ?
                                    <tr style={{ border: '2px solid', textAlign: 'center' }}>
                                        <td>{lis.employ_name}</td>
                                        <td>{lis.employ_phone1}</td>
                                        <td>{lis.employ_income_type == 'punish' ? "سزا" : " داهات - هی دیکە"}</td>
                                        <td>{numberbeautify(lis.employ_income_amount)} IQD</td>
                                        <td>{moment(lis.date).format('YYYY-MM-DD')}</td>
                                        <td>{lis.employ_income_note}</td>
                                    </tr>
                                    :
                                    <tr style={{ border: '2px solid', textAlign: 'center' }}>
                                        <td>{lis.employ_name}</td>
                                        <td>{lis.employ_phone1}</td>
                                        <td>{lis.employ_expense_type == 'salary' ? "موچە" : lis.employ_expense_type == 'lesson_part' ? "بەشەوانە" : lis.employ_expense_type == 'certificate' ? "بڕوانامە" : lis.employ_expense_type == 'service' ? "خزمەت" : lis.employ_expense_type == "reward" ? "پاداشت" : lis.employ_expense_type == "argment" ? "کۆمیشنی ڕێککەوتن" : "خەرجی - هی دیکە"}</td>
                                        <td>{numberbeautify(lis.employ_expense_amount)} IQD</td>
                                        <td>{moment(lis.date).format('YYYY-MM-DD')}</td>
                                        <td>{lis.employ_expense_note}</td>
                                    </tr>
                            ))}
                        </tbody>
                    </table>
                </Row>
                <div style={{ width: '100%', marginTop: '5vh', display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ width: '50%' }}>
                        <span>سارا سعدی عمر<br />
                            ژمێریار</span>
                    </div>
                    <div style={{ width: '50%', display: 'flex', justifyContent: "flex-end" }}>
                        <span>ئاڤان ئەحمەد حەمە<br />
                            بەڕێوەبەر</span>
                    </div>
                </div>
            </Container>
        </div>
    )
}

export default Checkoutprint